<template>
  <div>
    <HeaderComponent/>
    <SlideMenuComponent/>
    <div class="index">
      <div class="section1">
        <div class="wrap">
          <div class="border">

            <!--            <div class="swiper-container">-->
            <!--              <div class="swiper-wrapper">-->
            <!--                <div class="swiper-slide">-->
            <!--                  <img src="images/banner.jpg" alt="">-->
            <!--                </div>-->
            <!--                <div class="swiper-slide">-->
            <!--                  <img src="images/banner.jpg" alt="">-->
            <!--                </div>-->
            <!--                <div class="swiper-slide">-->
            <!--                  <img src="images/banner.jpg" alt="">-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

            <el-carousel class="el-carousel">
              <el-carousel-item class="el-carousel-item">
                <img src="images/start.png" alt="" style="border-radius: calc(30/1080*100vw);width: 100%;"
                     v-show="locale==='zh'">
                <img src="images/start_en.png" alt="" style="border-radius: calc(30/1080*100vw);width: 100%;"
                     v-show="locale==='en'">
              </el-carousel-item>
              <!--              <el-carousel-item class="el-carousel-item">-->
              <!--                <img src="images/banner.jpg" alt="" style="border-radius: calc(30/1080*100vw);width: 100%;height: 100%">-->
              <!--              </el-carousel-item>-->
              <!--              <el-carousel-item class="el-carousel-item">-->
              <!--                <img src="images/banner.jpg" alt="" style="border-radius: calc(30/1080*100vw);width: 100%;height: 100%">-->
              <!--              </el-carousel-item>-->
            </el-carousel>


          </div>
        </div>
      </div>
      <div class="section2">
        <div class="wrap">
          <div class="border">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <a href="#">{{ $t("comingSoon") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section3">
        <div class="wrap">
          <router-link to="hashRate">
            <span class="icon"><img src="images/ic1.png" alt=""></span>
            <span class="title">{{ $t("myHashrate") }}</span>
          </router-link>
          <router-link to="mining">
            <span class="icon"><img src="images/ic2.png" alt=""></span>
            <span class="title">{{ $t("hashrateMining") }}</span>
          </router-link>
          <a href="javascript:" @click="unOpened">
            <span class="icon"><img src="images/ic3.png" alt=""></span>
            <span class="title">{{ $t("stakingMining") }}</span>
          </a>
          <a href="javascript:" @click="unOpened">
            <span class="icon"><img src="images/ic4.png" alt=""></span>
            <span class="title">{{ $t("hashrateService") }}</span>
          </a>
          <a href="https://pancakeswap.finance/swap?inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0x0592c81e7aF7c7b7F4Bf8F43C43A5b5A9914EC5a"
             target="_blank">
            <span class="icon"><img src="images/ic5.png" alt=""></span>
            <span class="title">{{ $t("trade") }}</span>
          </a>
          <a href="https://pancakeswap.finance/add/0x55d398326f99059fF775485246999027B3197955/0x0592c81e7aF7c7b7F4Bf8F43C43A5b5A9914EC5a"
             target="_blank">
            <span class="icon"><img src="images/ic6.png" alt=""></span>
            <span class="title">{{ $t("addLiquidity") }}</span>
          </a>
          <a href="javascript:" @click="unOpened">
            <span class="icon"><img src="images/ic7.png" alt=""></span>
            <span class="title">{{ $t("helpCenter") }}</span>
          </a>
          <router-link to="/benefit">
            <span class="icon"><img src="images/ic8.png" alt=""></span>
            <span class="title">{{ $t("myWallet") }}</span>
          </router-link>
        </div>
      </div>
      <div class="section4">
        <div class="wrap">
          <div class="item">
            <div class="s1">
              <div class="icon"><img src="images/im1.png" alt=""></div>
              <div class="tit">{{ $t("token") }}</div>
            </div>
            <div class="s2">AIR1</div>
          </div>
          <div class="item">
            <div class="s1">
              <div class="icon"><img src="images/im2.png" alt=""></div>
              <div class="tit">{{ $t("price") }}</div>
            </div>
            <div class="s2">≈{{ price.toFixed(5) }} USD</div>
          </div>
          <div class="item">
            <div class="s1">
              <div class="icon"><img src="images/im3.png" alt=""></div>
              <div class="tit">{{ $t("liquidity") }}</div>
            </div>
            <div class="s2">{{ usdtReserves.toFixed(2) }} USDT/{{ tokenReserves.toFixed(2) }} AIR1</div>
          </div>
          <div class="item">
            <div class="s1">
              <div class="icon"><img src="images/im4.png" alt=""></div>
              <div class="tit">{{ $t("myBalance") }}</div>
            </div>
            <div class="s2">{{ balance }} AIR1</div>
          </div>
        </div>
      </div>
      <div class="section5">
        <div class="wrap">
          <router-link to="/mining" class="send">{{ $t("goToMining") }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import HeaderComponent from "@/components/HeaderComponent.vue";
import SlideMenuComponent from "@/components/SlideMenuComponent.vue";
import {default_pair_contract, default_token_contract} from "@/utils/ethRpc";
import {ethers} from "ethers";
import {mapState} from "vuex";
import {ElMessage} from "element-plus";

export default {
  name: 'HomeView',
  components: {
    SlideMenuComponent,
    HeaderComponent,
    HelloWorld
  },
  data: function () {
    return {
      usdtReserves: 0,
      tokenReserves: 0,
      price: 0,
      balance: 0
    }
  },
  computed: {
    ...mapState(['wallet_address', 'wallet_type']), // 映射 state
    locale() {
      return this.$i18n.locale
    }
  },
  methods: {
    async loadFromChain() {
      //获取pair流动性
      let reserves = await default_pair_contract.getReserves();
      // console.log("reserves", reserves)
      this.usdtReserves = (Number)(ethers.formatEther(reserves[1]))
      this.tokenReserves = (Number)(ethers.formatEther(reserves[0]));
      this.price = this.usdtReserves / this.tokenReserves

      if (this.wallet_address) {
        const balance = await default_token_contract.balanceOf(this.wallet_address);
        this.balance = (Number)(ethers.formatEther(balance))
      }
    },
    unOpened() {
      ElMessage.info({
        duration: "5000",
        message: this.$t("unOpened")
      })
    }
  },
  mounted() {

    const invitor = new URLSearchParams(window.location.search).get("invitor");
    console.log("invitor", invitor)
    if (invitor) {
      this.invitor = invitor
      localStorage.setItem('invitor', invitor)
    }

    this.loadFromChain();
    this.interval = setInterval(() => {
      this.loadFromChain()
    }, 3000)
  },
  unmounted() {
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
.el-carousel {
  width: 100%;
  border-radius: 20px;
  aspect-ratio: 560 / 368;
}

.el-carousel-item {
  width: 100%;
  aspect-ratio: 560 / 368;
}

.el-carousel img {
  width: 100%;
  height: auto;
  object-fit: fill;
}
</style>
